module.exports = __webpack_public_path__ + "img/overview.d172cb9e.gif";